import { __read } from 'tslib';
import { useContext, useEffect } from 'react';
import '../../contexts/GlobalActionsContext/GlobalActionsContext.esm.js';
import '../../contexts/ToggleContext/ToggleContext.esm.js';
import { VideoContext } from '../../contexts/VideoContext/VideoContext.esm.js';

var useVideoEvents = function (_a) {
    var contentfulPlayer = _a.contentfulPlayer, vimeoPlayer = _a.vimeoPlayer, videoModel = _a.videoModel, options = _a.options;
    var videoConfig = useContext(VideoContext);
    useEffect(function () {
        if (contentfulPlayer === null || contentfulPlayer === void 0 ? void 0 : contentfulPlayer.current) {
            Object.entries(videoConfig).map(function (_a) {
                var _b;
                var _c = __read(_a, 2), eventName = _c[0], fn = _c[1];
                (_b = contentfulPlayer.current) === null || _b === void 0 ? void 0 : _b.on(eventName, function () {
                    return fn({
                        contentfulPlayer: contentfulPlayer.current,
                        videoModel: videoModel,
                        videoOptions: options,
                    });
                });
            });
            return function () {
                Object.entries(videoConfig).map(function (_a) {
                    var _b;
                    var _c = __read(_a, 2), eventName = _c[0], fn = _c[1];
                    (_b = contentfulPlayer.current) === null || _b === void 0 ? void 0 : _b.off(eventName, fn);
                });
            };
        }
        if (vimeoPlayer === null || vimeoPlayer === void 0 ? void 0 : vimeoPlayer.current) {
            Object.entries(videoConfig).map(function (_a) {
                var _b;
                var _c = __read(_a, 2), eventName = _c[0], fn = _c[1];
                (_b = vimeoPlayer.current) === null || _b === void 0 ? void 0 : _b.on(eventName, function () {
                    return fn({
                        videoModel: videoModel,
                        videoOptions: options,
                        vimeoPlayer: vimeoPlayer.current,
                    });
                });
            });
            return function () {
                Object.entries(videoConfig).map(function (_a) {
                    var _b;
                    var _c = __read(_a, 2), eventName = _c[0], fn = _c[1];
                    (_b = vimeoPlayer.current) === null || _b === void 0 ? void 0 : _b.off(eventName, fn);
                });
            };
        }
    }, [contentfulPlayer === null || contentfulPlayer === void 0 ? void 0 : contentfulPlayer.current, vimeoPlayer === null || vimeoPlayer === void 0 ? void 0 : vimeoPlayer.current]);
};

export { useVideoEvents as default };
//# sourceMappingURL=useVideoEvents.esm.js.map
